import { render, staticRenderFns } from "./Extra-profile.vue?vue&type=template&id=2c2e8945&"
import script from "./Extra-profile.vue?vue&type=script&lang=js&"
export * from "./Extra-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports